(() => {
  const propertyName = 'Availability';
  const updateForm = (form) => {
    const data = form.querySelector('[data-mlb-shipping-variants]');
    const input = form.querySelector('[data-mlb-shipping-property]');
    if (!data || !input) return null;
    const variants = JSON.parse(data.textContent);
    const message = variants[form.elements.namedItem('id')?.value];
    if (input.disabled !== !message) input.disabled = !message;
    if (message && input.value !== message) input.value = message;
    return message;
  };
  const updateForms = () => {
    document.querySelectorAll('[data-mlb-shipping-property]').forEach(input => updateForm(input.form));
  };
  document.addEventListener('change', () => {
    updateForms();
    requestAnimationFrame(updateForms);
  });
  document.addEventListener('formdata', (event) => {
    const message = updateForm(event.target);
    if (message) event.formData.set(`properties[${propertyName}]`, message);
  }, true);
  updateForms();
  const root = window.Shopify?.routes?.root || '/';
  let pending;
  const synchronize = () => {
    if (pending) return pending;
    pending = (async () => {
      const url = new URL(`${root}cart`, location.origin);
      url.searchParams.set('section_id', 'mlb-checkout-availability');
      const response = await fetch(url, { cache: 'no-store' });
      if (!response.ok) throw new Error('Availability unavailable');
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const data = document.querySelector('[data-mlb-checkout-lines]');
      if (!data) throw new Error('Availability unavailable');
      for (const item of JSON.parse(data.textContent)) {
        const properties = Array.isArray(item.properties) ? Object.fromEntries(item.properties) : { ...item.properties };
        let removedLegacyNote = false;
        for (const [key, value] of Object.entries(properties)) {
          if (/^\d+$/.test(key) && ((Array.isArray(value) && value[0] === propertyName) || /^Availability(?:In Stock|Made to Order)/.test(String(value)))) {
            delete properties[key];
            removedLegacyNote = true;
          }
        }
        if (!item.message || (!removedLegacyNote && properties[propertyName] === item.message)) continue;
        const result = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: { ...properties, [propertyName]: item.message } })
        });
        if (!result.ok) throw new Error('Availability update failed');
      }
    })().finally(() => { pending = null; });
    return pending;
  };
  const showError = () => {
    window.alert(document.querySelector('[data-mlb-checkout-error]')?.dataset.mlbCheckoutError || 'We could not confirm the shipping estimate. Please try checkout again.');
  };
  const approvedForms = new WeakSet();
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (approvedForms.has(form)) {
      approvedForms.delete(form);
      return;
    }
    const button = event.submitter;
    if (button?.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    button.setAttribute('aria-busy', 'true');
    synchronize().then(() => {
      approvedForms.add(form);
      form.requestSubmit(button);
    }).catch(showError).finally(() => button.removeAttribute('aria-busy'));
  }, true);
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    synchronize().then(() => { location.href = url.href; }).catch(showError);
  }, true);
})();
